import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {BasicAnalysisResult} from '@/map/@types';
import {ANAYSIS_RESULT_LABELS} from '@/map/constants';
import {AreaAnalyticsFilter, BuildingType} from '@/map/enums';
import {getAreahouseReport, getHouseMarkerInfo, getSidoName} from '@/map/utils';
import {Flexbox, FlexFullGrow, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {withComma} from '@/utils';
import {
  ColorCircle, SectionLabel, SectionValue, Table, TableCell, TableHeaderRow, TableRow
} from '../StyledComponents';
import {CompareAverage} from './CompareAvg';

interface IProps {
  data?: BasicAnalysisResult;
}

export const Household = ({data}: IProps) => {
  const report = getAreahouseReport(data);
  const house = report?.house;
  const isEmpty = !house || !(house.total || house.upcomingAparts);

  if (isEmpty) {
    return (
      <Root>
        <Flexbox>
          <SectionLabel>배후 세대</SectionLabel>
          <FlexFullGrow />
          <SectionValue color={palette.gray300}>정보 없음</SectionValue>
        </Flexbox>
      </Root>
    );
  }

  if (!house) {
    return null;
  }

  const ctprvn = getSidoName(data?.average?.sido);
  const avg = data?.average?.[AreaAnalyticsFilter.HOUSE];

  return (
    <Root>
      <Flexbox>
        <SectionLabel>배후 세대</SectionLabel>
        <FlexFullGrow />
        <SectionValue>{withComma(house.total)} 세대</SectionValue>
      </Flexbox>
      {!!avg && (
        <PaddingBox top={8}>
          <CompareAverage total={house.total} average={avg} ctprvn={ctprvn} />
        </PaddingBox>
      )}
      <PaddingBox top={20}>
        <Table>
          <thead>
            <TableHeaderRow>
              <TableCell>분류</TableCell>
              <TableCell>세대수(비중)</TableCell>
            </TableHeaderRow>
          </thead>
          <tbody>
            {Object.entries(house)
              .filter(([key, value]) => key !== 'total' && value > 0)
              .map(([key, value]) => {
                const markerInfo = getHouseMarkerInfo(key);

                if (key === AreaAnalyticsFilter.UPCOMMING_APTS) {
                  if (!house.APT) {
                    <TableRow key={key}>
                      <TableCell>
                        <Flexbox>
                          <ColorDot color={markerInfo?.color} />
                          아파트 입주예정
                        </Flexbox>
                      </TableCell>
                      <TableCell>{withComma(value)}</TableCell>
                    </TableRow>;
                  } else {
                    return null;
                  }
                }

                const hasUpcomming =
                  key === BuildingType.Apartment &&
                  !!house[AreaAnalyticsFilter.UPCOMMING_APTS];

                return (
                  <TableRow key={key}>
                    <TableCell>
                      <Flexbox>
                        <ColorDot color={markerInfo?.color} />
                        <div>
                          {ANAYSIS_RESULT_LABELS[key]}
                          {hasUpcomming && (
                            <PaddingBox top={4}>
                              <Typography
                                variant="medium12"
                                color={palette.gray500}
                              >
                                입주 예정
                              </Typography>
                            </PaddingBox>
                          )}
                        </div>
                      </Flexbox>
                    </TableCell>
                    <TableCell>
                      {withComma(value)}
                      {hasUpcomming && (
                        <PaddingBox top={4}>
                          <Typography
                            variant="medium12"
                            color={palette.gray500}
                          >
                            {withComma(
                              house[AreaAnalyticsFilter.UPCOMMING_APTS]
                            )}
                          </Typography>
                        </PaddingBox>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </tbody>
        </Table>
      </PaddingBox>
    </Root>
  );
};

const Root = styled.div``;

const ColorDot = styled(ColorCircle)`
  margin-right: 20px;
`;
